<section>
  <header>
    @if(currentViewState() === viewStates.Detail){
      <nav>
        <img src="/assets/img/mobile/blue-arrow-left.svg" alt="arrow left" width="8" height="17" />
        <span class="linkspan" (click)="goBackToList()">Go to the Macromolecules list </span>
      </nav>
    }
    <section class="header">
      <h2>
        {{ title() }} @if(currentViewState() === viewStates.List){
        <span>({{ mappedMacromolecules().length }})</span>
      }
    </h2>
    <div class="controls">
      <img src="/assets/img/mobile/mb-arrow-{{expanded() ? 'down':'up'}}.svg" alt="arrow up" width="28" height="28" (click)="toggleBottomsheetHeight()" />
    </div>
  </section>
</header>

@if(mappedMacromolecules().length > 0 ){
  <div style="padding: 12px;">
    @if(currentViewState() === viewStates.List){ @for(macromolecule of mappedMacromolecules(); track macromolecule.displayTitle + macromolecule.displayChains; let i = $index;){
      <div class="mb-domains-container" (click)="navigateToDetail(macromolecule)">
        <div class="domain-parent">
          <div class="mb-domain-info">
            <div class="mb-domain-title">{{ macromolecule.displayTitle }}</div>
            <img class="arrow-right-icon" alt="" src="/assets/img/mobile/arrow-right.svg" width="16" height="16">
          </div>
          <div class="mb-domain-boundaries">{{ macromolecule.displayChains }}</div>
        </div>
      </div>
      }}

      @if(currentViewState() === viewStates.Detail){
        <div class="detail-view">
          @if (!showChainDropdown()) {
            <span class="detail-chain">{{ getActiveChainHeading() }}</span>
          }
          @if (showChainDropdown()) {
            <entry-dropdown
              class="detail-chain-dropdown"
              [downloadable]="false"
              [islink]="false"
              [options]="chainDropdownOptions"
              [title]="getActiveChainTitle()"
              (optionClickedEvent)="onChainDropdownSelect($event)">
            </entry-dropdown>
          }

          <mat-tab-group
            class="detail-tabs"
            [selectedIndex]="detailTabIndex()"
            (selectedIndexChange)="onDetailTabChange($event)"
            animationDuration="0ms"
            >
            <mat-tab label="Model Confidence">
              <div class="content tab-panel">
                <div class="metric-row">
                  <div class="metric-label">{{ getActiveChainTitle() }} quality</div>
                  <div class="metric-value">average pLDDT: {{ getAveragePlddtDisplay(activeMacromolecule()) }}</div>
                </div>

                @if (hasInterfaceQuality()) {
                  <div class="metric-row interface-row">
                    <div class="metric-label">Interface quality</div>
                    <div class="metric-value stacked-values">
                      @if (complexData().complexPredictionAccuracy_ipSAE !== null && complexData().complexPredictionAccuracy_ipSAE !== undefined) {
                        <div>
                          ipSAE: {{ complexData().complexPredictionAccuracy_ipSAE }} ({{ getIpSaeLevel(complexData().complexPredictionAccuracy_ipSAE) }})
                        </div>
                      }
                      @if (complexData().complexPredictionAccuracy_ipTM !== null && complexData().complexPredictionAccuracy_ipTM !== undefined) {
                        <div>
                          ipTM: {{ complexData().complexPredictionAccuracy_ipTM }}
                        </div>
                      }
                      @if (complexData().complexPredictionAccuracy_pDockQ2 !== null && complexData().complexPredictionAccuracy_pDockQ2 !== undefined) {
                        <div>
                          pDockQ2: {{ complexData().complexPredictionAccuracy_pDockQ2 }}
                        </div>
                      }
                      @if (complexData().complexPredictionAccuracy_LIS !== null && complexData().complexPredictionAccuracy_LIS !== undefined) {
                        <div>
                          LIS: {{ complexData().complexPredictionAccuracy_LIS }}
                        </div>
                      }
                    </div>
                  </div>
                }

                <div class="legendsmobile">
                  <linear-legends type="plddt"></linear-legends>
                </div>
                <div class="legendstext">
                  <span>
                    pLDDT is a per-residue measure of local confidence
                    <br />
                    <a href="./faq/#faq-12" target="_blank" class="licenseLink">Learn more...</a>
                  </span>
                </div>
              </div>
            </mat-tab>

            <mat-tab label="Information">
              <div class="content tab-panel">
                <div class="section-heading">{{ getActiveChainHeading() }}</div>

                <div class="text-parent">
                  <div class="download-text">Gene</div>
                  <div class="desc">{{ activeMacromolecule()?.gene || 'Not available' }}</div>
                </div>

                <div class="text-parent">
                  <div class="download-text">Source organism</div>
                  <div class="desc"><i>{{ activeMacromolecule()?.organismScientificName || 'Not available' }}</i></div>
                </div>

                <div class="text-parent">
                  <div class="download-text">UniProt</div>
                  <div class="desc">
                    {{ activeMacromolecule()?.uniprotAccession }}
                    @if (activeMacromoleculeRange(); as range) {
                      @if (range.start !== 1) {
                        [residues: {{ range.start }} – {{ range.end }}]
                      }
                    }
                    @if (activeMacromolecule()?.uniprotAccession) {
                      <a
                        class="mb-cath-link-desc ext action-link"
                        [href]="'https://www.uniprot.org/uniprotkb/' + activeMacromolecule()?.uniprotAccession"
                        target="_blank"
                        (click)="onRelatedEntryClick('uniprot_link')"
                      > go to UniProt</a>
                    }
                    @if (!activeMacromolecule()?.uniprotAccession) {
                      <span>Not available</span>
                    }
                  </div>
                </div>

                <div class="text-parent">
                  <div class="download-text">Biological function</div>
                  <div class="desc biological-function-text">
                    @if (isBiologicalFunctionLoading()) {
                      <span>Loading...</span>
                    }
                    @if (!isBiologicalFunctionLoading() && isBiologicalFunctionExpanded()) {
                      <span [innerHTML]="biologicalFunction().text"></span>
                    }
                    @if (!isBiologicalFunctionLoading() && !isBiologicalFunctionExpanded()) {
                      <span [innerHTML]="getShortenedBiologicalFunctionText()"></span>
                    }
                    @if (!isBiologicalFunctionLoading() && canShowMoreBiologicalFunction()) {
                      <a
                        class="vf-link action-link"
                        (click)="toggleBiologicalFunctionText()"
                      >{{ isBiologicalFunctionExpanded() ? 'Show less' : 'Show more...' }}</a>
                    }
                    @if (!isBiologicalFunctionLoading() && biologicalFunction().source && biologicalFunction().source !== 'tooltip') {
                      <a
                        [href]="biologicalFunction().source_url"
                        target="_blank"
                        class="vf-link ext action-link"
                        (click)="onRelatedEntryClick('go_to_uniprot')"
                      >go to {{ biologicalFunction().source }}</a>
                    }
                  </div>
                </div>

                <div class="text-parent">
                  <div class="download-text">Also a component in</div>
                  <div class="desc">
                    @if (isAlsoComponentInLoading()) {
                      <span>Loading...</span>
                    }
                    @if (!isAlsoComponentInLoading() && alsoComponentInCount() !== null) {
                      <span>
                        {{ alsoComponentInCount() }} entries in AFDB
                        @if (activeMacromolecule()?.uniprotAccession) {
                          <a
                            [href]="'/search/text/' + activeMacromolecule()?.uniprotAccession"
                            class="vf-link ext action-link"
                            target="_blank"
                            (click)="onRelatedEntryClick('also_component_in')"
                          >go to search</a>
                        }
                      </span>
                    }
                    @if (!isAlsoComponentInLoading() && alsoComponentInCount() === null) {
                      <span>Not available</span>
                    }
                  </div>
                </div>

                <div class="text-parent">
                  <div class="download-text">Experimental structures</div>
                  <div class="desc">
                    {{ getExperimentalStructuresText() }}
                    @if (activeMacromolecule()?.uniprotAccession && kbCount() !== null && kbCount() > 0) {
                      <a
                        [href]="'https://www.ebi.ac.uk/pdbe/pdbe-kb/proteins/' + activeMacromolecule()?.uniprotAccession"
                        target="_blank"
                        class="vf-link ext action-link"
                        (click)="onRelatedEntryClick('go_to_KB')"
                      >go to PDBe-KB</a>
                    }
                  </div>
                </div>
              </div>
            </mat-tab>

            <mat-tab label="Sequence">
              <div class="content tab-panel">
                <div class="sequence-actions">
                  <span class="sequence-title">{{ getActiveChainHeading() }}</span>
                  <div class="label-tooltip-seq">
                    @if (isCopySequence) {
                      <span class="label-tooltip-seq-text">Sequence copied</span>
                    }
                    <button (click)="copySequence(getActiveSequence())">Copy sequence</button>
                  </div>
                </div>
                <div class="sequence-box">{{ getActiveSequence() || 'Sequence not available' }}</div>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
      }
    </div>
  }
  @else{
  <div style="padding: 12px;">
    <div class="no-domain-parent">
      <div class="no-domain-information">No macromolecule information available</div>
      <div class="infocontainer">
        <p class="mb-desctext">Macromolecule annotations will appear here if data becomes available in future updates.</p>
      </div>
    </div>
  </div>
}
</section>